import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[oklch(var(--secondary-500))] text-[oklch(var(--background-50))]">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h3 className="text-lg font-bold font-heading mb-4">韩漫网</h3>
              <p className="text-sm text-[oklch(var(--background-50)_/_0.8)] leading-relaxed">
                韩漫网是领先的韩国漫画在线阅读平台，提供海量免费韩国漫画资源。高清画质、流畅阅读体验，让您随时随地享受韩漫的精彩世界。
              </p>
            </div>
            <div>
              <h4 className="text-sm font-semibold mb-4">快速导航</h4>
              <div className="flex flex-col gap-3">
                <Link to="/" className="text-sm text-[oklch(var(--background-50)_/_0.8)] hover:text-[oklch(var(--background-50))] transition-colors whitespace-nowrap">
                  首页
                </Link>
                <Link to="/category/romance" className="text-sm text-[oklch(var(--background-50)_/_0.8)] hover:text-[oklch(var(--background-50))] transition-colors whitespace-nowrap">
                  漫画分类
                </Link>
                <Link to="/about" className="text-sm text-[oklch(var(--background-50)_/_0.8)] hover:text-[oklch(var(--background-50))] transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold mb-4">热门分类</h4>
              <div className="flex flex-col gap-3">
                <Link to="/category/romance" className="text-sm text-[oklch(var(--background-50)_/_0.8)] hover:text-[oklch(var(--background-50))] transition-colors whitespace-nowrap">
                  浪漫爱情
                </Link>
                <Link to="/category/fantasy" className="text-sm text-[oklch(var(--background-50)_/_0.8)] hover:text-[oklch(var(--background-50))] transition-colors whitespace-nowrap">
                  奇幻冒险
                </Link>
                <Link to="/category/action" className="text-sm text-[oklch(var(--background-50)_/_0.8)] hover:text-[oklch(var(--background-50))] transition-colors whitespace-nowrap">
                  热血动作
                </Link>
                <Link to="/category/drama" className="text-sm text-[oklch(var(--background-50)_/_0.8)] hover:text-[oklch(var(--background-50))] transition-colors whitespace-nowrap">
                  都市剧情
                </Link>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold mb-4">关注我们</h4>
              <p className="text-sm text-[oklch(var(--background-50)_/_0.8)] mb-4">
                获取最新漫画更新和优惠信息
              </p>
              <div className="flex gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-[oklch(var(--background-50)_/_0.15)] hover:bg-[oklch(var(--background-50)_/_0.25)] transition-colors" aria-label="微信">
                  <i className="ri-wechat-line text-base" />
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-[oklch(var(--background-50)_/_0.15)] hover:bg-[oklch(var(--background-50)_/_0.25)] transition-colors" aria-label="微博">
                  <i className="ri-weibo-line text-base" />
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-[oklch(var(--background-50)_/_0.15)] hover:bg-[oklch(var(--background-50)_/_0.25)] transition-colors" aria-label="QQ">
                  <i className="ri-qq-line text-base" />
                </a>
              </div>
            </div>
          </div>
          <div className="border-t border-[oklch(var(--background-50)_/_0.15)] mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-[oklch(var(--background-50)_/_0.6)]">
              &copy; 2026 韩漫网 - 免费韩国漫画在线阅读平台。本站内容仅供学习交流。
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-xs text-[oklch(var(--background-50)_/_0.6)] hover:text-[oklch(var(--background-50)_/_0.8)] transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-[oklch(var(--background-50)_/_0.6)] hover:text-[oklch(var(--background-50)_/_0.8)] transition-colors whitespace-nowrap">服务条款</a>
              <a href="#" className="text-xs text-[oklch(var(--background-50)_/_0.6)] hover:text-[oklch(var(--background-50)_/_0.8)] transition-colors whitespace-nowrap">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}